var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"college-item"},[_c('img',{attrs:{"src":_vm.formatAvatar(_vm.item.traditional_image)}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.item.course_num)+"節課程")])])
}
var staticRenderFns = []

export { render, staticRenderFns }